import React, { useContext, useEffect, useRef, useState } from "react";
import { Col, Row, Tab, Tabs } from "react-bootstrap";
import { EmployeeTransfersDto } from "../../../../dtos/documents/EmployeeTransfers/EmployeeTransfersDto";
import { FormProvider, Resolver, useForm } from "react-hook-form";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { NewDocumentModalViewContext } from "../../../Shared/NewDocumentModalView";
import { DocumentModalViewHeader } from "../../../Shared/DocumentModalViewHeader";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";
import { NFTextAreaInput } from "../../../Shared/NewForms/NFTextAreaInput";
import { NFLookupCompany } from "../../../Shared/NewForms/NFLookupCompany";
import { NFLookupDivision } from "../../../Shared/NewForms/NFLookupDivision";
import { NFLookupWarehouse } from "../../../Shared/NewForms/NFLookupWarehouse";
import { NFLookupProduct } from "../../../Shared/NewForms/NFLookupProduct";
import { NFIntInput } from "../../../Shared/NewForms/NFIntInput";
import { NFLookupPosition } from "../../../Shared/NewForms/NFLookupPosition";
import { NFLookupWorkSchedule } from "../../../Shared/NewForms/NFLookupWorkSchedule";
import { EmployeeTransfersModel } from "../../../../models/Documents/EmployeeTransfers/EmployeeTransfersModel";
import { NFTabs } from "../../../Shared/NewForms/NFTabs";
import { NFTab } from "../../../Shared/NewForms/NFTab";
import { NFTabContainer } from "../../../Shared/NewForms/NFTabContainer";
import handleFormSubmit, { DocumentSaveActionType } from "../../../../helpers/DocumentHelper";
import EmployeeTransfersDetailSkeleton from "./EmployeeTransfersDetailSkeleton";
import { AppEntities } from "../../../../config/entities";
import { importFromExcel } from "../../../../helpers/SaveObjectToExcel";
import { saveObjectToExcel } from "../../../../helpers/SaveObjectToExcel";
import { EmployeeTransfersDetailFooter } from "./EmployeeTransfersDetailFooter";

interface IProps {
  model: EmployeeTransfersDto | null;
  modelUpdatedEvent: (newModel: EmployeeTransfersDto) => void;
}

// const resolver: Resolver<OpenBalanceOfGoodsDto> = async (values) => {
//     return {
//         values: values.documentNumber ? values : {},
//         errors: !values.documentNumber
//             ? {
//                 documentNumber: {
//                     type: 'required',
//                     message: 'This is required.',
//                 },
//             }
//             : {},
//     };
// };

export const EmployeeTransfersDetail = ({ model, modelUpdatedEvent }: IProps) => {
  const [tabIndex, setTabIndex] = useState(0);
  const [fileName, setFileName] = useState("Employee Transfers");

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<EmployeeTransfersModel>();

  const modalViewContext = useContext(NewDocumentModalViewContext);
  const { postHandler, saveHandler, closeHandler, cancelHandler } = modalViewContext;
  // const watchProducts = watch("postingOfGoodGoods");

  useEffect(() => {
    console.log(model);
    // register("postingOfGoodGoods");
    if (model) {
      setValue("id", model.id);
      setValue("documentNumber", model.documentNumber);
      setValue("documentDate", model.documentDate);
      setValue("departureDate", model.departureDate);
      setValue("personId", model.personId);
      setValue("comment", model.comment);
      setValue("companyId", model.companyId);
      setValue("createdDate", model.createdDate);
      setValue("operationType", model.operationType);
      setValue("transferDate", model.transferDate);
      setValue("positionId", model.positionId);
      setValue("divisionId", model.divisionId);
      setValue("companySalary", model.companySalary);
      setValue("salaryInsurance", model.salaryInsurance);
      setValue("workScheduleId", model.workScheduleId);
    }
  }, [model]);

  // useEffect(() => {
  //     console.log(watchProducts);
  // }, [watchProducts]);

  // const handleFormSubmit = (
  //   action: DocumentSaveActionType,
  //   data: EmployeeTransfersModel
  // ) => {
  //   console.log("form submit");
  //   console.log(data);
  //   console.log(action);
  //   if (action === "save") {
  //     const newModel: EmployeeTransfersModel = { ...model, ...data };
  //     console.log("new model");
  //     console.log(newModel);
  //     // if (modelUpdatedEvent) modelUpdatedEvent(newModel);
  //     saveHandler(newModel);
  //   } else if (action === "post") {
  //     postHandler();
  //   }
  // };

  const handleFormSubmitLocal = async (action: DocumentSaveActionType, data: EmployeeTransfersModel) => {
    await handleFormSubmit(action, data, model, saveHandler, postHandler);
  };

  if (!model) {
    return (
      <>
        <EmployeeTransfersDetailSkeleton />
      </>
    );
  }

  const exportToExcel = () => {
    const data = {
      ...model
    };
    const documentInfo = {
      title: AppEntities.EmployeeTransfers.title,
      number: model.documentNumber,
      date: model.documentDate
    };
    saveObjectToExcel(data, documentInfo);
  };

  const handleUploadFile = (file: File) => {
    importFromExcel(file, (data: any) => {
      reset(data);
    });
  };
  return (
    <FormProvider
      getValues={getValues}
      setValue={setValue}
      register={register}
      control={control}
      trigger={trigger}
      reset={reset}
      watch={watch}
      handleSubmit={handleSubmit}
      formState={formState}
      {...methods}
    >
      <NFTabs
        onTabChange={(newIndex) => {
          setTabIndex(newIndex);
        }}
      >
        <NFTab title={"Main"} />
        <NFTab title={"Additional"} />
      </NFTabs>

      <div className={"modal-container-height"}>
        <DocumentModalViewHeader
          onPost={handleSubmit((data) => handleFormSubmitLocal("post", data))}
          onSave={handleSubmit((data) => handleFormSubmitLocal("save", data))}
          onClose={closeHandler}
          onCancel={cancelHandler}
          handleUploadFile={handleUploadFile}
          exportToExcel={exportToExcel}
          fileName={fileName}
          setFileName={setFileName}
        />

        <NFTabContainer index={0} currentIndex={tabIndex}>
          <div className={"panel-body tabs-menu-body main-content-body-right"}>
            <Row>
              <Col sm={6}>
                <NFTextInput title={"Document #"} disabled fieldName={"documentNumber"} />
              </Col>
              <Col sm={6}>
                <NFDateInput title={"Document Date"} fieldName={"documentDate"} required={true} />
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <NFDateInput title={"Transfer Date"} fieldName={"transferDate"} required={true} />
              </Col>
              <Col sm={6}>
                <NFIntInput fieldName={"operationType"} title={"operationType"} />
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <NFLookupCompany title={"Company"} fieldName={"companyId"} />
              </Col>
              <Col sm={6}>
                <NFLookupPosition fieldName={"positionId"} title={"Position"} />
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <NFIntInput fieldName={"companySalary"} title={"companySalary"} />
              </Col>
              <Col sm={6}>
                <NFIntInput fieldName={"salaryInsurance"} title={"salaryInsurance"} />
              </Col>
            </Row>

            <Row>
              <Col sm={6}>
                <NFLookupDivision title={"Division"} fieldName={"divisionId"} />
              </Col>
              <Col sm={6}>
                <NFLookupWorkSchedule fieldName={"workScheduleId"} title={"Work Schedule"} />
              </Col>
            </Row>
          </div>
        </NFTabContainer>

        <NFTabContainer index={1} currentIndex={tabIndex}>
          <div className={"panel-body tabs-menu-body main-content-body-right"}>
            <Row>
              <Col sm={12}>
                <NFTextAreaInput fieldName={"comment"} title={"Comment"} required={false} />
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <NFTextInput title={"Created User"} fieldName={"createdUser"} disabled={true} />
              </Col>
              <Col sm={6}>
                <NFDateInput title={"Created Date"} fieldName={"createdDate"} disabled={true} />
              </Col>
            </Row>
          </div>
        </NFTabContainer>
      </div>
      <EmployeeTransfersDetailFooter/>
    </FormProvider>
  );
};
